<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("admin_tools.tabs.integration_list") }}
      UiStackItem
        UiButton(
          @click="exportIntegrations()"
          icon="FileDownload"
        ) {{ $t("companies.export_to_excel") }}
  UiCardSection
    RestTable(
      namespace="integration_list"
      :headers="headers"
      ref="integrationListTable"
      :fetch-handler="getData"
      embed
    )
</template>
<script>
import ApiIntegrationList from "@/api/integration_list.js";

export default {
  data() {
    return {
      headers: [
        {
          key: "company_name",
          label: "Name",
          sortable: true,
        },
        {
          key: "netvisor_organization_id",
          label: "BusinessId",
          sortable: true,
        },
        {
          key: "netvisor_user_id",
          label: "Netvisor User ID",
          sortable: true,
        },
      ],
    };
  },

  methods: {
    getData(params, config) {
      return ApiIntegrationList.fetchIntegrationList(params, config).then(
        (resp) => {
          return {
            items: resp.data.integration_list,
            meta: resp.data.meta,
          };
        },
      );
    },
    exportIntegrations() {
      ApiIntegrationList.exportIntegrations()
        .then((resp) => {
          let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `integrations_list.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },
  },
};
</script>
